export default {
  SEARCH_ALLIANZ_ACCOUNT_MOVEMENTS_REPORT_QUERY: Symbol.for('SEARCH_ALLIANZ_ACCOUNT_MOVEMENTS_REPORT_QUERY'),
  ALLIANZ_ACCOUNT_MOVEMENT_REPORT_REPOSITORY: Symbol.for('ALLIANZ_ACCOUNT_MOVEMENT_REPORT_REPOSITORY'),
  ALLIANZ_ACCOUNT_MOVEMENT_REPORT_STATE_MANAGER: Symbol.for('ALLIANZ_ACCOUNT_MOVEMENT_REPORT_STATE_MANAGER'),
};
